Office.onReady(() => {
  const language = Office.context.displayLanguage;

  function onNewMessageComposeHandler(event) {
    const addinEnabled = Office.context.roamingSettings.get("addinEnabled") !== "false";
    if (!addinEnabled) {
      if (language.includes("es")) {
        showNotification("Knowee Signatures está deshabilitado, abra el panel para habilitarlo.");
      } else {
        showNotification("Knowee Signatures is disabled, open the panel to enable it.");
      }
      event.completed();
      return;
    }
    const apinetToken = Office.context.roamingSettings.get("apinetToken");
    if (apinetToken) {
      loginWithApinetToken(apinetToken, event);
    } else {
      loginWithSSO(event);
    }
  }

  async function loginWithApinetToken(apinetToken, event) {
    performLoginApinetToken(apinetToken)
      .then((res) => {
        if (res.status === "no_signature") {
          if (language.includes("es")) {
            showNotification("No tienes firmas configuradas en Knowee Signatures.");
          } else {
            showNotification("You don't have any signature configured in Knowee Signatures.");
          }
        }
        if (res.status === "config_signature_required") {
          if (language.includes("es")) {
            showNotification("Por favor, abre el panel de Knowee Signatures para configurar tu firma por defecto.");
          } else {
            showNotification("Please, open the Knowee Signatures panel to configure your default signature.");
          }
        }
        if (res.signature) {
          colocarFirma(res.signature, event);
        } else {
          event.completed();
        }
      })
      .catch(() => {
        loginWithSSO(event);
      });
  }

  function loginWithSSO(event) {
    performSSO(true)
      .then((res) => {
        if (res.status === "config_signature_required") {
          if (language.includes("es")) {
            showNotification("Por favor, abre el panel de Knowee Signatures para configurar tu firma por defecto.");
          } else {
            showNotification("Please, open the Knowee Signatures panel to configure your default signature.");
          }
        }
        if (res.signature) {
          colocarFirma(res.signature, event);
        } else {
          event.completed();
        }
      })
      .catch(() => {
        if (language.includes("es")) {
          showNotification("Por favor, abre el panel de Knowee Signatures para iniciar sesión.");
        } else {
          showNotification("Please, open the Knowee Signatures panel to sign in.");
        }
        event.completed();
      });
  }

  function colocarFirma(signature, event) {
    Office.context.mailbox.item.body.setSignatureAsync(
      signature.file,
      {
        coercionType: "html",
        asyncContext: event,
      },
      function (asyncResult) {
        asyncResult.asyncContext.completed();
      }
    );
  }

  function showNotification(msg) {
    let text = "Open panel";
    let errorText = "Error showing notification:";
    if (language.includes("es")) {
      text = "Abrir panel";
      errorText = "Error al mostrar la notificación:";
    }
    const message = {
      type: Office.MailboxEnums.ItemNotificationMessageType.InsightMessage,
      message: msg,
      icon: "Icon.80x80",
      actions: [
        {
          actionType: Office.MailboxEnums.ActionType.ShowTaskPane,
          actionText: text,
          commandId: "msgComposeOpenPaneButton",
          isPrimary: true,
          text: text,
        },
      ],
    };

    Office.context.mailbox.item.notificationMessages.replaceAsync("notification", message, (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        console.error(errorText, result.error);
      }
    });
  }

  Office.actions.associate("onNewMessageComposeHandler", onNewMessageComposeHandler);
});
